<template>
    <div
        class="wizard-step dm-wizard-navigation-step step"
        data-wizard-type="step"
        :data-wizard-state="wizardState"
        :class="phaseClass"
        @click="goToStep"
        :title="tooltipText"
    >
        <div
            class="wizard-icon position-relative"
            :class="{ 'dm-incomplete-step': showIncompleteIcon, 'bg-warning' : step_data.is_done == false && highlight_incomplete_steps }"
            :title="tooltipText"
        >
            <span class="wizard-number">{{ step_data.number }}</span>
            <span class="wizard-check">
                <span class="svg-icon svg-icon-2x">
                    <CheckSvg />
                </span>
            </span>
            <!-- <span
                v-if="step_data.is_mandatory"
                class="dm-is-mandatory-badge"
                title="Is Mandatory"
                >M</span
            > -->
        </div>
        <div class="wizard-label w-100">
            <h3 class="wizard-title">{{ translate(step_data.name) }}</h3>
        </div>

        <div
            v-if="step_data.is_last_in_phase"
            class="dm-phase-arrow"
        >
        </div>
    </div>
</template>

<script>
import CheckSvg from "@/svg/CheckSvg.vue";
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState } from "pinia";

export default {
    components: { CheckSvg },

    props: ["step_data", "step"],

    computed: {
        ...mapState(useSubmissionWizardStore, [
            "current_route_name",
            "highlight_incomplete_steps",
        ]),

        phaseClass() {
            let classes = "dm-phase-" + this.step_data.phase;

            if (this.step_data.is_first_in_phase)
                classes = classes + " dm-first-in-phase";
            if (this.step_data.is_last_in_phase)
                classes = classes + " dm-last-in-phase";

            return classes;
        },

        showIncompleteIcon() {
            // if (this.isCurrentStep) return false;
            if (!this.step_data.is_mandatory) return false;
            if (
                this.wizardState == "pending" &&
                this.highlight_incomplete_steps
            )
                return true; // NB: This triggers the highlight after the 'Submit' button is triggered on the Bio step
            if (this.wizardState == "pending") return false;
            return false;
        },
        tooltipText() {
            if (!this.showIncompleteIcon) return "";
            return "Complete this step before submitting the manuscript";
        },
        isCurrentStep() {
            return this.step_data.slug == this.current_route_name;
        },
        wizardState() {
            if (this.isCurrentStep) return "current";
            if (this.step_data.is_done) return "done";
            return "pending";
        },
    },

    methods: {
        goToStep() {
            if (this.isCurrentStep)
                // This avoids Vue Router redundant navigation warning.
                return;
            this.$router.push({ name: this.step_data.slug }); // NB: The Vue Router route names match the Step slugs.
            this.scrollToTop();
            setTimeout(() => {
                this.scrollToStepOnMobile();
            }, "200");
        },

        scrollToTop() {
            jQuery("html, body").animate({ scrollTop: 0 });
        },

        scrollToStepOnMobile() {
            $(".wizard-nav").animate(
                {
                    scrollLeft: $(
                        '.dm-wizard-steps div[data-wizard-state="current"]',
                    ).position().left,
                },
                500,
            );
        },
    },
};
</script>
